import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { changeObjectPropertyAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import { StatusInputWrapper } from '../../../../shared/components/StatusInputWrapper'

const BusinessName = ({ t, validateBusinessName, businessNameError, businessNameValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const businessName = useSelector((state) => state.app.businessVehicleInformation.businessName)

  const handleBusinessName = (e) => {
    try {
      let name = e.currentTarget.value;
      dispatch(changeObjectPropertyAction('businessVehicleInformation', 'businessName', name))
      validateBusinessName(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurBusinessName = (e) => {
    try {
      SetIsFocussed(false)
      let name = e.currentTarget.value.trim()
      dispatch(changeObjectPropertyAction('businessVehicleInformation', 'businessName', name))
      validateBusinessName(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <StatusInputWrapper
      isValid={businessNameValid}
      errorMsg={businessNameError}
      t={t}
      label={t('business_vehicle_info.business_name')}
      customClasses={'fw-20'}
      id="BusinessName" name="BusinessName" type="text"
      aria-describedby="business-name"
      onChange={handleBusinessName}
      onBlur={onBlurBusinessName}
      onFocus={() => SetIsFocussed(true)}
      isFocussed={isFocussed}
      value={businessName}
      autoComplete="off"
      maxLength="150"
    />
  )
}

export default withTranslation('common')(BusinessName)